// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"135":"fe72c2a9","604":"45efe790","721":"cadc10fe","787":"b9ec5bb0","940":"422ea0d1"}[chunkId] + ".chunk.js";
};